import React from "react";
import HowItWorks from "@/components/Common/HowItWorks";
import TrustedByMany from "@/components/Common/TrustedByMany";
import FeaturedOn from "@/components/Common/FeaturedOn";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import Hero from "@/components/Common/Hero";
import { createClient } from "../../../../prismicio";
import { SliceZone } from "@prismicio/react";
import Metadata from "@/components/Metadata";
import FAQ from "@/components/Common/FAQ";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import SchemaScript from "@/components/SchemaScript";

const SilverBuyers = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  return (
    <Layout data={commonComponents}>
      <SchemaScript data={pageData?.schema_json} />
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/what-we-buy/silver-buyers"
      />
      <Hero
        caption={pageData?.hero_caption || ""}
        title={pageData?.hero_title || ""}
        sideImage={pageData?.hero_side_image.url || ""}
        sideImageMobile={pageData?.hero_mobile_side_image.url || ""}
        backgroundImage={pageData?.hero_background_image}
        description={pageData?.hero_description || ""}
        features={pageData?.hero_feature_list || []}
        page={"Silver Buyers"}
      />
      <Breadcrumbs />
      <HowItWorks data={pageData} />
      <TrustedByMany data={commonComponents} page={"Silver Buyers"} />
      <FeaturedOn data={commonComponents} />
      <SliceZone slices={page?.data?.slices2} components={components} />
      <FreeAppraisal whiteBg={true} data={pageData} page={"Silver Buyers"} />
    </Layout>
  );
};

export default SilverBuyers;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("silver_buyer_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
